import { render, staticRenderFns } from "./tanimlama.vue?vue&type=template&id=e4625efa&scoped=true&"
import script from "./tanimlama.vue?vue&type=script&lang=js&"
export * from "./tanimlama.vue?vue&type=script&lang=js&"
import style0 from "./tanimlama.vue?vue&type=style&index=0&id=e4625efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4625efa",
  null
  
)

export default component.exports